
	<section class="download fade-in" *ngIf="data['Show This Section'] == 'true'">
		<div class="col image">
			<img src="/assets/images/download-hero.png">
		</div>
		<div class="col qr-holder">
			<p class="headline">{{ headlineText }}</p>
			<ng-container *ngIf="data['EAP App Text Override']?.trim(); else defaultAppTextTpl">
				<p class="text">{{ data['EAP App Text Override'] }}</p>
			</ng-container>
			<ng-template #defaultAppTextTpl>
				<p class="text no-scan-qr-text">{{ defaultAppTextNoScan }}</p>
				<p class="text scan-qr-text">{{ defaultAppText }}</p>
			</ng-template>
			<div class="get-app">
				<div class="qr-code desktop" *ngIf="data['QR Code']">
					<img [src]="data['QR Code']">
				</div>
				<div class="app-links">
					<img class="desktop" src="/assets/images/download-arrow.png" *ngIf="data['QR Code']">
					<p class="desktop" *ngIf="data['QR Code']">{{ scanText }}</p>
					<ul>
						<li *ngIf="data['Google Play Link']"><a [href]="data['Google Play Link']" target="_blank" [interact]="{engagementTypeID: 4, resource: 'Google Play Link'}"><img src="/assets/images/Google-Play_x2.png"></a></li>
						<li *ngIf="data['Apple Store Link']"><a [href]="data['Apple Store Link']" target="_blank" [interact]="{engagementTypeID: 4, resource: 'Apple Store Link'}"><img src="/assets/images/App-Store_x2.png"></a></li>
					</ul>
				</div>
			</div>
		</div>
		<div class="col">
		</div>
		<div class="register-row" *ngIf="eapUrl || eapPhone || groupCode">
			<span class="group-code" *ngIf="groupCode"><b [innerHTML]="groupCodeLabel || 'Enter group code'"></b>:&nbsp;<span class="cta-value notranslate">{{ groupCode }}</span></span>
			<a *ngIf="eapUrl" class="cta" [href]="eapUrl" target="_blank">{{ registerText }}</a>
			<a *ngIf="!eapUrl && eapPhone" class="cta" [href]="'tel:' + sanitizePhone(eapPhone)">{{ registerText }}</a>
		</div>
	</section>
